import React, { useState, useContext, useEffect, useRef } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import ComprasFaturadas from './../../ComprasFaturadas/ComprasFaturadas';
import Rodape from '../../Rodape/Rodape';
import { useLocation, useHistory } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { identificacaoUsuarioLogado } from './../../../utils';
import 'react-toastify/dist/ReactToastify.css';
import { MyContext } from '../../../context/MyContext';
import api from './../../../services/api';
import { makeStyles } from '@mui/styles';
import LogoNafil from '../../../assets/img/NAFIL_logo.svg';
import LogoN from '../../../assets/img/NAFIL_logoCurto.svg';
import ImpressaoIcon from '../../../assets/img/impressora.svg';
import CloseIcon from '../../../assets/img/close.svg';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Box from '@mui/material/Box';
import PaginaCardNotasFaturadas from '../../CardNotasFaturadas/CardNotasFaturadas';
import PaginaCardNotasFaturadasReciboPagamentos from '../../CardNotasFaturadasRecibosPagamentos/CardNotasFaturadasRecibosPagamentos';

//function FaturadoLinkDePagamento() {
const FaturadoLinkDePagamento = () => {
  const componentRef = useRef();
  const location = useLocation();  
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const [linkPagamento, SetLinkPagamento] = useState(null);
  // const [_userId, Set_userId] = useState(null);
  // const [_userIdloja, Set_userIdloja] = useState(null);
  // const [_processoId, Set_processoId] = useState(null);
  // const [_processoIdLoja, Set_processoIdLoja] = useState(null);
  // const [_nomeFullRazaoSocialLogado, Set_nomeFullRazaoSocialLogado] = useState(null);
  const [satonImpressaoProcessoId, setSatonImpressaoProcessoId] = useState(null);
  const [satonImpressaoProcessoIdLoja, setSatonImpressaoProcessoIdLoja] = useState(null);
  const [dadosConteudoParaImpressao, setDadosConteudoParaImpressao] = useState(null);
  const [corpoMensagem, setCorpoMensagem] = useState("Aguarde, Abrindo a Página de Pagamentos... ");
  const [retorno, SetRetorno] = useState([]);
  const [linkPagamentoMensagem, SetLinkPagamentoMensagem] = useState(null);
  const { showModalMeuPagamentoFaturado, setShowModalMeuPagamentoFaturado } = useContext(MyContext);
  const { destinoPagina, setDestinoPagina } = useContext(MyContext);  
  const { showModalMeuPagamentoFaturadoReciboDePagamento, setShowModalMeuPagamentoFaturadoReciboDePagamento } = useContext(MyContext);
  
  const toastMensagemError = (message) => toast.error(message,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const descriptografarLinkPagamento = async (dados) => {
    const objeto = { encryptedText: dados };

    console.log("MIGUEL 33 ", dados);
    const ret = await api.post(`Saton/UsarLinkPagamentoFaturado`, objeto).then((response) => {

      console.log("MIGUEL 6 ", response.data);
      SetLinkPagamento(response.data);

    }).catch((e) => {
      
      console.log("MIGUEL 7 ");
      
      SetLinkPagamento(null);
      toastMensagemError("Falha Geral: " + e.message)
    });
  }

  useEffect(() => {    
    // const dados = JSON.parse(`{"EncryptedText":"${queryParams.get('pagamento')}"}`);    
    if (linkPagamento != null) {
      setCorpoMensagem("");
      setDestinoPagina("/");
      abrirPaginaParaConcluirPagamentos(linkPagamento.split("/"));
    }else if (linkPagamento == null){
      SetLinkPagamentoMensagem({ cabecalho: "Link de Pagamento Inválido", corpo: "Por Favor, Solicite ao Emissor um Novo Link de Pagamento." });
    }
  }, [linkPagamento]);

  useEffect(() => {
    // const dados = JSON.parse(`{"EncryptedText":"${queryParams.get('pagamento')}"}`);    
    if (corpoMensagem == "") {
      //      setCorpoMensagem("");
      //    abrirPaginaParaConcluirPagamentos(linkPagamento.split("/"));
    }
  }, [corpoMensagem]);


  useEffect(() => {
    //const dados = JSON.parse(`{"encryptedText":"${queryParams.get('pagamento')}"}`);
    const dados = queryParams.get('pagamento');
    const aguardar = async (dados) => {
      await descriptografarLinkPagamento(dados);
    };
    aguardar(dados);
  }, []);


  const modalStyleReciboPagamentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '500px',
    width: '90%', // Garante responsividade e centralização mesmo em telas menores
    bgcolor: 'background.paper',
    boxShadow: 24,
    // p: 4, // Padding interno do modal (opcional)
    overflow: 'auto',
  }

  const modalStyle = {
    position: 'absolute',
    top: '10%',
    left: '10%',
    right: "10%",
    overflow: 'scroll',
    height: '87%',
    display: 'block',
    bgcolor: 'background.paper',
    boxShadow: 24
  }

  const handleCloseModal = () => {    
    setShowModalMeuPagamentoFaturado(false);        
  }

  const abrirPaginaParaConcluirPagamentos = async (linkPagamento) => {

    console.log("ACHEI", linkPagamento);

    let _userId = linkPagamento[0].split("=")[1]; // idCliente
    let _userIdloja = linkPagamento[1].split("=")[1]; // idClienteLoja
    let _processoId = linkPagamento[4].split("=")[1]; // idProcesso
    let _processoIdLoja = linkPagamento[5].split("=")[1]; // idProcessoLoja
    let _expiraEm = linkPagamento[6].split("=")[1]; // expiraEm
    let _nomeFullRazaoSocialLogado = "EUDES AUTO MEC. REZENDE LTDA"; // Razão Social

    setSatonImpressaoProcessoId(_processoId);
    setSatonImpressaoProcessoIdLoja(_processoIdLoja);
    let dados = null;
    try {
      let APIdados = await api.get(`Saton/ProcessoPagamentoRelatorio/${_userId}/${_userIdloja}/${_processoId}/${_processoIdLoja}/${_nomeFullRazaoSocialLogado}`)
        .then((response) => {

          console.log("MIGUEL 2 ", response.data);

          setDadosConteudoParaImpressao(response.data);
          setShowModalMeuPagamentoFaturado(true);
        })
        .catch((erro) => {
          setDadosConteudoParaImpressao(null);
          toastMensagemError("Falhou: " + erro.message)
        });
    } catch (e) {
      setDadosConteudoParaImpressao(null);
      toastMensagemError("Falha Geral: " + e.message)
      return null;
    };
  };


  return (
    <div display="flex"
      flexDirection="column"
      minHeight="100vh">

      <NavBarTop />
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        {corpoMensagem}
      </Box>
      {
        showModalMeuPagamentoFaturado ?
          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={setShowModalMeuPagamentoFaturado}
              onClose={handleCloseModal}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={showModalMeuPagamentoFaturado}>
                <Box sx={modalStyle}>
                  {/* <DetalhesMeuPagamentoFaturado props={JSON.parse('{"idProcesso":145, "idProcessoLoja":998, "idCliente":91, "idClienteLoja":1}')} /> */}
                  {/* <PaginaCardNotasFaturadas props={JSON.parse('{"codigo":123, "descricao":"ABC", "unitario":4.56 }')} />  */}
                  <PaginaCardNotasFaturadas props={dadosConteudoParaImpressao} />
                </Box>
              </Fade>
            </Modal>
          </div>
          : <></>
      }

      {
        showModalMeuPagamentoFaturadoReciboDePagamento ?
          <div>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={setShowModalMeuPagamentoFaturadoReciboDePagamento}
              onClose={handleCloseModal}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={showModalMeuPagamentoFaturadoReciboDePagamento}>
                <Box sx={modalStyleReciboPagamentos} ref={componentRef}>
                  <PaginaCardNotasFaturadasReciboPagamentos props={dadosConteudoParaImpressao} />
                </Box>
              </Fade>
            </Modal>
          </div>
          : <></>
      }
      <ToastContainer />
      <Rodape />
    </div>
  );
}
export default FaturadoLinkDePagamento;